export const ADVISOR_DAY_PREFIX = 'advisor-day:';
export const ADVISOR_ITEM_PREFIX = 'advisor-item:';
export const ADVISOR_RAIL_DROP_ID = 'advisor-rail';
/** The pinned trip total (T-398) hides the rail beneath it: no drops. */
export const ADVISOR_TOTALS_ID = 'advisor-totals';
/** Catalogue cards; the same prefix the console's source cards use. */
export const ADVISOR_SOURCE_PREFIX = 'source-product:';

export const advisorSourceDragId = (productId: string): string =>
  `${ADVISOR_SOURCE_PREFIX}${productId}`;

export const parseAdvisorSourceDragId = (id: string): string | null =>
  id.startsWith(ADVISOR_SOURCE_PREFIX)
    ? id.slice(ADVISOR_SOURCE_PREFIX.length)
    : null;

export const advisorDayDropId = (dayId: string): string =>
  `${ADVISOR_DAY_PREFIX}${dayId}`;

export const advisorItemDragId = (itemId: string): string =>
  `${ADVISOR_ITEM_PREFIX}${itemId}`;

export const parseAdvisorDayDropId = (id: string): string | null =>
  id.startsWith(ADVISOR_DAY_PREFIX)
    ? id.slice(ADVISOR_DAY_PREFIX.length)
    : null;

export const parseAdvisorItemDragId = (id: string): string | null =>
  id.startsWith(ADVISOR_ITEM_PREFIX)
    ? id.slice(ADVISOR_ITEM_PREFIX.length)
    : null;
